var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.brandLimitOffers.filter(function (offer) { return offer.copay_offer_id; })),function(offer){return _c('VBrandLimitOfferListItem',{key:offer.copay_offer_id,attrs:{"offer":offer,"isReadonly":_vm.isReadonly},on:{"remove":function($event){return _vm.$emit('remove', offer)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35bd45f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VBrandLimitOfferList.vue
// module id = null
// module chunks = 